import { render, staticRenderFns } from "./PPublishedProjectSwitchSearchFilter.vue?vue&type=template&id=c52a03ca&scoped=true&"
import script from "./PPublishedProjectSwitchSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./PPublishedProjectSwitchSearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PPublishedProjectSwitchSearchFilter.vue?vue&type=style&index=0&id=c52a03ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a03ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
